export default __webpack_public_path__ + "static/media/Advanced Potion Making - Final_17.8f428fa5.jpg";